import { createSlice } from '@reduxjs/toolkit';

interface UserState {
  currentUser: any;
}

const initialState: UserState = {
  currentUser: {},
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.currentUser = action.payload;
    },
    setLogout: (state) => {
      state.currentUser = {};
    },
  },
});

export const { setUser, setLogout } = userSlice.actions;

export default userSlice.reducer;
